/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, createSelector, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit';
import { FilterFieldOption } from 'components/common/form';
import { ApiState } from 'models';
import { getRelationShips } from 'services';

export type State = ApiState<FilterFieldOption[], SerializedError>;

// https://redux-toolkit.js.org/api/createAsyncThunk
export const fetchRelationships = createAsyncThunk('get/relationships', async () => await getRelationShips());

export const initialState = {
  isLoading: false,
  hasLoaded: false,
  data: [],
  error: null,
} as State;

//https://redux-toolkit.js.org/api/createSlice
const relationshipsSlice = createSlice({
  name: 'relationships',
  initialState,
  //immer is behind the scenes to keep state immutable only the props you changes will be changed
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchRelationships.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchRelationships.fulfilled, (state, action: PayloadAction<string[]>) => {
      state.isLoading = false;
      state.data = action.payload.map((value) => ({ id: value, label: value }));
      state.hasLoaded = true;
    });

    builder.addCase(fetchRelationships.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

export const stateSelector_ = (state: { relationships: State }): State => state.relationships;

export const relationships_ = createSelector(stateSelector_, (state) => state.data);

export default relationshipsSlice.reducer;
